module.exports = __webpack_public_path__ + "static/media/9@3x.a266beae.png";